// src/components/ProtectedRoute.js
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../services/firebase";
import useIdleTimeout from "../hooks/useIdleTimeout";

// Inner component — only renders (and runs the hook) when user is confirmed authenticated
function AuthenticatedApp({ children }) {
  useIdleTimeout();
  return children;
}

export default function ProtectedRoute({ children }) {
  const [user, setUser] = useState(undefined); // undefined = still checking

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setUser(u || null));
    return () => unsub();
  }, []);

  // Still checking auth state — render nothing to avoid flash
  if (user === undefined) return null;

  // Not logged in — redirect to home
  if (!user) return <Navigate to="/" replace />;

  // Logged in — wrap in AuthenticatedApp which activates the idle timer
  return <AuthenticatedApp>{children}</AuthenticatedApp>;
}
